import * as d3 from "d3";

export class DataPoints {
  private balanceGraph: any;
  private xScale: d3.ScaleTime<number, number, never>;
  private yScale: d3.ScaleLinear<number, number, never>;

  constructor(
    balanceGraph: any,
    xScale: d3.ScaleTime<number, number, never>,
    yScale: d3.ScaleLinear<number, number, never>,
  ) {
    this.balanceGraph = balanceGraph;
    this.xScale = xScale;
    this.yScale = yScale;
  }

  generatePointData(balancesByTime: Map<string, number>): number[][] {
    const dataPoints: number[][] = [];

    for (const data of balancesByTime) {
      const xValue = this.xScale(new Date(Number(data[0]) * 1000));
      if (data[1] !== null) {
        const yValue = this.yScale(data[1]);
        dataPoints.push([xValue, yValue]);
      }
    }
    return dataPoints;
  }

  /**
   * Generate dates array corresponding to point data for x-axis highlighting
   */
  generatePointDates(balancesByTime: Map<string, number>): number[] {
    const dates: number[] = [];
    for (const data of balancesByTime) {
      if (data[1] !== null) {
        dates.push(Number(data[0])); // Store date in seconds
      }
    }
    return dates;
  }

  updatePoints(name: string, pointData: number[][], className?: string) {
    const points = this.balanceGraph.selectAll(`[id^="${name}`).data(pointData);

    points
      .join("circle")
      .attr("id", (d: number[], i: number) => {
        return name + "_" + i;
      })
      .attr("class", className ? className + " closing-point" : "closing-point")
      .attr("cx", (d: number[]) => d[0])
      .attr("cy", (d: number[]) => d[1])
      .attr("r", 6);
  }

  setOpeningPoints(name: string, openingPoints: number[]) {
    openingPoints.forEach((index: number) => {
      const points = this.balanceGraph.selectAll(`#${name}_${index}`);
      points.classed("closing-point", false);
      points.classed("opening-point", true);
    });
  }

  setSelectedPoint(name: string, index: number) {
    this.clearSelectedPoint();
    const points = this.balanceGraph.selectAll(`#${name}_${index}`);
    points.classed("selected-point", true);
  }

  clearSelectedPoint() {
    this.balanceGraph
      .selectAll(".selected-point")
      .classed("default-point", false)
      .classed("selected-point", false);
  }

  setDefaultPoint(name: string, index: number) {
    const points = this.balanceGraph.selectAll(`#${name}_${index}`);
    points.classed("default-point", true);
  }

  /**
   * Removes every point circle drawn by updatePoints, across every path (balance-chart draws
   * one set, scenario-chart draws one per path). Selects both the "closing-point" and
   * "opening-point" classes - setOpeningPoints re-tags index 0 of every path from closing to
   * opening on every render, so a selector for closing-point alone always misses that one
   * circle (#4602).
   */
  removeAllPoints() {
    this.balanceGraph.selectAll(".closing-point, .opening-point").remove();
  }
}
